<template>
  <div class="form-container">
    <question-title :question="question" />
    <div v-if="atLeastOneImage" class="answers-container">
      <div
        v-for="(answer, index) in possibleAnswers"
        :key="answer.answerId"
        class="answer-container answer-image-container"
      >
        <answer-image-input
          v-bind="{ poll, answer, index, isSelected: isAnswerSelected(answer.answerId) }"
          @answerSelected="selectAnswer"
        />
      </div>
    </div>

    <div v-else>
      <div
        v-for="(answer, index) in possibleAnswers"
        :key="answer.answerId"
        class="answer-container"
        :class="{ 'correct-answer': (displayCorrectAnswer === true && answer.isGood) }"
      >
        <answer-text-input
          v-bind="{ poll, answer, index, isSelected: isAnswerSelected(answer.answerId) }"
          @answerSelected="selectAnswer"
          :displayCorrectAnswer="displayCorrectAnswer"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { getPossibleAnswers } from 'polle-shared-formatters';
import AnswerTextInput from '@/components/inputs/AnswerTextInput';
import AnswerImageInput from '@/components/inputs/AnswerImageInput';
import QuestionTitle from './QuestionTitle';
import { mergeAnswers } from '../utils';

export default {
  name: 'question-form',
  components: {
    QuestionTitle,
    AnswerTextInput,
    AnswerImageInput
  },
  props: {
    poll: Object,
    question: Object,
    answers: Array,
    questionStats: Object,
    displayCorrectAnswer: Boolean
  },
  data: () => ({
    selectedAnswersIds: []
  }),
  computed: {
    atLeastOneImage() {
      return this.answers.some(answer => answer.image);
    },
    possibleAnswers() {
      // get answers from stats to have isGood property
      return getPossibleAnswers(this.question, mergeAnswers(this.answers, this.questionStats.answers));
    }
  },
  methods: {
    selectAnswer(answerId) {
      const answerIsAlreadySelected = this.isAnswerSelected(answerId);
      // if the answer is already selected and we clicked on it, unselect it
      if (answerIsAlreadySelected) {
        this.selectedAnswersIds = this.selectedAnswersIds.filter(
          selectedAnswerId => selectedAnswerId !== answerId
        );
        return;
      }
      // for QUIZZ questions we can select multiple answers,
      // so add the newly selected answer to the selected ones
      if (this.question.type === 'QUIZZ') {
        return this.selectedAnswersIds.push(answerId);
      }
      // for other question types, only select the one we just selected
      this.selectedAnswersIds = [answerId];
    },

    isAnswerSelected(answerId) {
      return !!this.selectedAnswersIds.find(selectedAnswerId => selectedAnswerId === answerId);
    }
  },
  watch: {
    selectedAnswersIds(value) {
      this.$emit('answersSelected', {
        questionId: this.question.questionId,
        answersIds: value
      });
    },
    // eslint-disable-next-line
    question(value) {
      // clear election on question change
      this.selectedAnswersIds = []
    }
  }
};
</script>

<style lang="scss" scoped>
.form-container {
  padding: 10px 10px 40px 10px;
}

.answers-container {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
}

.answer-image-container {
  flex: 0 50%;
  border-radius: 50px;
}

.answer-container {
  margin: 10px 0;
}
</style>
